import { ArrowRight } from 'lucide-react'

import { Reveal } from '@/components/ui/Reveal'

import { SectionLabel } from './HowItWorks'

const cities = [
  { count: 86, name: 'Mumbai' },
  { count: 74, name: 'Bengaluru' },
  { count: 61, name: 'Hyderabad' },
  { count: 55, name: 'Chennai' },
  { count: 48, name: 'Delhi NCR' },
  { count: 42, name: 'Pune' },
  { count: 38, name: 'Kolkata' },
  { count: 32, name: 'Ahmedabad' },
]

export function Cities() {
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-12 py-20" id="cities">
      <SectionLabel>Browse by city</SectionLabel>
      <Reveal delay={0.05}>
        <h2
          className="font-display font-bold leading-[1.1] tracking-tight mb-12"
          style={{
            color: 'var(--text)',
            fontSize: 'clamp(1.9rem,3.5vw,2.8rem)',
            letterSpacing: '-.5px',
            maxWidth: 520,
          }}
        >
          Turfs in your city
        </h2>
      </Reveal>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {cities.map((c, i) => (
          <Reveal delay={i * 0.06} key={c.name}>
            <button
              className="w-full flex items-center justify-between px-5 py-5 rounded-2xl text-left border transition-all duration-200 hover:-translate-y-0.5"
              onMouseEnter={(e) => (e.currentTarget.style.borderColor = 'rgba(184,236,60,.4)')}
              onMouseLeave={(e) => (e.currentTarget.style.borderColor = 'var(--lime-line)')}
              style={{ background: 'var(--bg3)', borderColor: 'var(--lime-line)' }}
            >
              <div>
                <div
                  className="font-display font-semibold text-[1.05rem] mb-0.5"
                  style={{ color: 'var(--text)' }}
                >
                  {c.name}
                </div>
                <div className="text-[0.75rem]" style={{ color: 'var(--muted)' }}>
                  {c.count} turfs
                </div>
              </div>
              <ArrowRight size={18} style={{ color: 'var(--lime)', opacity: 0.5 }} />
            </button>
          </Reveal>
        ))}
      </div>
    </section>
  )
}
